import React, { Component } from "react";

import "./Left.less";

export default class Left extends Component {
  render() {
    const style = {
      ...this.props.style,
      width: this.props.width,
    };
    return (
      <div
        className={"nano-panel-left " + (this.props.className || "")}
        style={style}
      >
        {this.props.children}
      </div>
    );
  };
}
